var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":`${_vm.prefixClass}-zoom-in-down`}},[(_vm.visible)?_c('div',{class:`${_vm.prefixClass}-datepicker-main ${_vm.prefixClass}-datepicker-popup`,style:({ top: _vm.top, left: _vm.left, position: 'absolute' })},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }